import React from 'react';

/** CSS-only product frame for the hero — no screenshots required. */
const HeroProductPreview: React.FC = () => (
  <div className="cp-landing-preview" aria-hidden>
    <div className="cp-landing-preview__chrome">
      <span className="cp-landing-preview__dot" />
      <span className="cp-landing-preview__dot" />
      <span className="cp-landing-preview__dot" />
    </div>
    <div className="cp-landing-preview__body">
      <div className="cp-landing-preview__sidebar">
        <span className="cp-landing-preview__nav-item cp-landing-preview__nav-item--active" />
        <span className="cp-landing-preview__nav-item" />
        <span className="cp-landing-preview__nav-item" />
        <span className="cp-landing-preview__nav-item" />
      </div>
      <div className="cp-landing-preview__main">
        <div className="cp-landing-preview__stats">
          <span className="cp-landing-preview__stat">
            <span className="cp-landing-preview__stat-label" />
            <span className="cp-landing-preview__stat-value" />
          </span>
          <span className="cp-landing-preview__stat">
            <span className="cp-landing-preview__stat-label" />
            <span className="cp-landing-preview__stat-value cp-landing-preview__stat-value--accent" />
          </span>
          <span className="cp-landing-preview__stat">
            <span className="cp-landing-preview__stat-label" />
            <span className="cp-landing-preview__stat-value" />
          </span>
        </div>
        <div className="cp-landing-preview__chart">
          <span className="cp-landing-preview__bar" style={{ height: '42%' }} />
          <span className="cp-landing-preview__bar" style={{ height: '68%' }} />
          <span className="cp-landing-preview__bar" style={{ height: '55%' }} />
          <span className="cp-landing-preview__bar" style={{ height: '82%' }} />
          <span className="cp-landing-preview__bar" style={{ height: '61%' }} />
          <span
            className="cp-landing-preview__bar cp-landing-preview__bar--highlight"
            style={{ height: '94%' }}
          />
        </div>
        <div className="cp-landing-preview__rows">
          <span className="cp-landing-preview__row" />
          <span className="cp-landing-preview__row" />
          <span className="cp-landing-preview__row cp-landing-preview__row--short" />
        </div>
      </div>
    </div>
  </div>
);

export default HeroProductPreview;
